/**
 * Keydown/keypress guard that restricts input to numeric characters only.
 * If the pressed key is outside the ASCII range for digits (0-9), the
 * default action is prevented so the character is not entered into the
 * bound input control.
 * @param event The keyboard event dispatched from the input element.
 * @returns void
 */
export function isNumber(event: any): void {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    event.preventDefault();
  }
}

/**
 * Keydown handler that blocks the space character from being entered into
 * an input control. Useful for fields such as the canvasser code or OTP
 * where whitespace is not a valid character.
 * @param event The KeyboardEvent produced by the input element.
 * @returns void
 */
export function preventSpace(event: KeyboardEvent): void {
  if (event.key === ' ') {
    event.preventDefault();
  }
}
